/**
 *
 * @author Nandhini Narasimhan @ 12/04/2018 14:43
 * @description
 * @notes
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import {cloneDeep} from "lodash"
import styled from "styled-components"

import notify from "@irati/utils/notify"
import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import IconText from "@irati/ui/src/IconText"
import {ENABLED, DISABLED} from "@irati/insights/constants/schedule"
import {updateSchedule} from "@irati/insights/services/schedule"
import {isScheduleEnabled, hasScheduleRunAtLeastOnce} from "../../../helpers/schedule"
import tracking from "../../../tracking/survey"

const StyledIconText = styled(IconText)`
  white-space: nowrap;
`
class ButtonToggleSchedule extends Component {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    schedule: PropTypes.object,
    onChange: PropTypes.func,
    onErrorRedirectTo: PropTypes.string,
    pauseCopy: PropTypes.string
  }

  static defaultProps = {
    schedule: {},
    onChange: () => undefined,
    onErrorRedirectTo: null,
    pauseCopy: "Pause"
  }

  constructor(props) {
    super(props)
    this.state = {
      submit: null
    }
  }

  handleClick = () => {
    const {schedule, onChange, onErrorRedirectTo, formatMessage} = this.props
    tracking.surveyEmployeeEngagementStatus(schedule, DISABLED)
    /** Clone and toggle the schedule status */
    const clonedSchedule = cloneDeep(schedule)
    clonedSchedule.status = isScheduleEnabled(clonedSchedule) ? DISABLED : ENABLED

    /** Save that status change */
    const submit = updateSchedule(clonedSchedule)
      .then(() => onChange())
      .catch((error) => {
        tracking.errorsEmployeeEngagement()
        notify.error({message: formatMessage({id: error.contentKey}), position: "bottom-right"})
        /** Using async on ButtonRouterLink allows you to return a url to navigate to post promise */
        return onErrorRedirectTo
      })
    this.setState({submit})

    return submit
  }

  render() {
    const idNamespace = id("schedule-status-button", this.props)
    const {schedule, pauseCopy} = this.props
    const {submit} = this.state
    const startResumeCopy = hasScheduleRunAtLeastOnce(schedule) ? "Resume" : "Start"
    return (
      <ButtonRouterLink primary large async id={idNamespace} onClick={this.handleClick} load={submit}>
        {isScheduleEnabled(schedule) ? (
          <StyledIconText icon="pause">{pauseCopy}</StyledIconText>
        ) : (
          <StyledIconText icon="play">{startResumeCopy}</StyledIconText>
        )}
      </ButtonRouterLink>
    )
  }
}

export default injectIntl(ButtonToggleSchedule)
